// 関連トピックス
(function () {
  const $path = location.pathname;
  const $lang = location.pathname.includes('/en/') ? 'en' : 'ja';
  const $langPath = location.pathname.includes('/en/') ? '/en' : '';

  let DUMMY_IMG = '/common/images/default.webp';
  let MAX_COUNT = 3;

  // 現在ページの出力タグコード
  let thisOutputTagGroup = '';
  if($path.includes('/ir/investor/')) {
    thisOutputTagGroup = 'sr';
  } else if($path.includes('/sustainability/')) {
    thisOutputTagGroup = 'sustainability';
  } else if($path.includes('/innovation/research/')) {
    thisOutputTagGroup = 'innovation';
  } else if($path.includes('/innovation/dx/')) {
    thisOutputTagGroup = 'dx';
  }

  function getNewsId() {
    let path = location.pathname;
    let fileName = path.split('/').filter(Boolean).pop() || '';
    return fileName.replace(/\.html$/, '');
  }

  function fetchJson(url) {
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('fetch error: ' + url + ' (' + res.status + ')');
      return res.json();
    });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    let thisDate = new Date(dateStr);
		let year = thisDate.getFullYear();
		let month = ('0' + (thisDate.getMonth() + 1)).slice(-2); // 月は0始まりのため+1
		let day = ('0' + thisDate.getDate()).slice(-2);
    if($lang === 'ja') {
      return `${year}年${month}月${day}日`;
    } else {
      const monthShort = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${monthShort[thisDate.getMonth()]} ${thisDate.getDate()}, ${year}`;
    }
  }

  function createCard(item) {
    let imgSrc   = item.cf_t_thum_img ? '/topics/topics_file/file/' + item.cf_t_thum_img : DUMMY_IMG;
    let imgAlt   = item.cf_t_thum_img_alt || '';
    let imgTitle = item.cf_t_thum_img_title || '';
    let title    = item.cf_t_title || '';
    let date     = formatDate(item.cf_t_date);
    let type     = item.cf_t_type || '';
    let icon = '';

    let tags = (item.cf_t_tags || []);
    let outputTags = (item.cf_t_output_tags || []);
    let outputTagGroup = item.cf_t_output_tag_group;

    let groupTagName = thisOutputTagGroup;
    if (!outputTagGroup.includes(thisOutputTagGroup)) {
      groupTagName = outputTagGroup[0];
    }
    // ディレクトリを設定
    let groupTagDirectory = '';
    if(groupTagName === 'sr') {
      groupTagDirectory = 'ir/investor'
    } else if(groupTagName === 'sustainability') {
      groupTagDirectory = 'sustainability'
    } else if(groupTagName === 'innovation') {
      groupTagDirectory = 'innovation/research'
    } else if(groupTagName === 'dx') {
      groupTagDirectory = 'innovation/dx'
    }

    let href = `${$langPath}/${groupTagDirectory}/topics/detail/${item._key}.html`;

    let tagSpans = [];
    tags.forEach(function (t) {
      let name = t['cf_tt_name_' + $lang];
      if (name) {
        tagSpans.push(
          '<span class="js-category cf_t_tags">' +
            '<span class="stories-tagarea__category">' + escHtml(name) + '</span>' +
          '</span>'
        );
      }
    });
    outputTags.forEach(function (t) {
      let name = t['cf_tot_name_' + $lang];
      if (name) {
        tagSpans.push(
          '<span class="js-category cf_t_output_tags">' +
            '<span class="stories-tagarea__category">' + escHtml(name) + '</span>' +
          '</span>'
        );
      }
    });

    let categoriesHtml = '';
    if (tagSpans.length) {
      categoriesHtml = '<div class="stories-tagarea__categories">' + tagSpans.join('') + '</div>';
    }

    let dateHtml = date ? '<time class="mod-boxLink03__date">' + escHtml(date) + '</time>' : '';

    let a = document.createElement('a');
    a.href = href;

    if(type === 2) { // 添付ファイル
      a.target = '_blank';
      a.href = item.cf_t_attachment_file;
      if(item.cf_t_attachment_file.includes('.pdf')) {
        icon = '<svg aria-label="PDF"><use href="/common/svg/sprite.svg#pdf"></use></svg>';
      }
      icon += ' <span class="__fileSize">('+ fileSize(item.cf_t_attachment_file_size) +')</span>';
    } else if(type === 3) { //  URL指定
      a.href = item.cf_t_url;
      if(item.cf_t_url.includes('//')) {
        a.target = '_blank';
        a.rel = 'noopener';
        icon = '<svg aria-hidden="true"><use href="/common/svg/sprite.svg#blank"></use></svg>';
        console.log('item.cf_t_url_file_size',item.cf_t_url_file_size)
        if(item.cf_t_url_file_size !== '' && item.cf_t_url_file_size !== undefined && item.cf_t_url_file_size !== null) {
          icon += ' <span class="__fileSize">('+ fileSize(item.cf_t_url_file_size) +')</span>';
        }
      }
    }

    a.className = 'mod-boxLink03';
    a.innerHTML =
      '<div class="mod-boxLink03__frame _border">' +
        '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(imgAlt) + '" title="' + escHtml(imgTitle) + '" class="mod-boxLink03__img" />' +
      '</div>' +
      '<div class="mod-boxLink03__content">' +
        '<p class="mod-boxLink03__title"><span class="_text">' + escHtml(title) + '</span>' +
        icon +
        '</p>' +
        categoriesHtml +
        dateHtml +
      '</div>';
    return a;
  }

  let SLIDES_PER_VIEW = 2;

  function updateCarousel(carouselEl, carouselIndex, totalCards) {
    let trackEl = carouselEl.querySelector('.mod-card-carousel__track');
    if (!trackEl) return;
    trackEl.style.transform = 'translateX(-' + (carouselIndex * 50) + '%)';
    let prevBtn = carouselEl.querySelector('.mod-card-carousel__btn--prev');
    let nextBtn = carouselEl.querySelector('.mod-card-carousel__btn--next');
    if (prevBtn) prevBtn.style.display = carouselIndex > 0 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = carouselIndex < totalCards - SLIDES_PER_VIEW ? 'flex' : 'none';
  }

  function setupCarousel(grid) {
    if (!grid) return;
    let isMobile = window.innerWidth <= 1024;

    let carouselEl = grid.nextElementSibling;
    let isCarouselActive = carouselEl && carouselEl.classList.contains('mod-card-carousel');

    if (isMobile && !isCarouselActive) {
      let carouselIndex = 0;
      let cards = Array.from(grid.querySelectorAll(':scope > .mod-boxLink03'));
      if (!cards.length) return;

      carouselEl = document.createElement('div');
      carouselEl.className = 'mod-card-carousel';

      let trackEl = document.createElement('div');
      trackEl.className = 'mod-card-carousel__track';

      cards.forEach(function (card) {
        let slide = document.createElement('div');
        slide.className = 'mod-card-carousel__slide';
        slide.appendChild(card);
        trackEl.appendChild(slide);
      });

      carouselEl.appendChild(trackEl);

      let prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--prev';
      prevBtn.setAttribute('aria-label', '前へ');
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_left"></use></svg>';
      prevBtn.addEventListener('click', function () {
        carouselIndex = carouselIndex > 0 ? carouselIndex - 1 : Math.max(0, cards.length - SLIDES_PER_VIEW);
        updateCarousel(carouselEl, carouselIndex, cards.length);
      });

      let nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--next';
      nextBtn.setAttribute('aria-label', '次へ');
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>';
      nextBtn.addEventListener('click', function () {
        carouselIndex = carouselIndex < cards.length - SLIDES_PER_VIEW ? carouselIndex + 1 : 0;
        updateCarousel(carouselEl, carouselIndex, cards.length);
      });

      carouselEl.appendChild(prevBtn);
      carouselEl.appendChild(nextBtn);

      grid.parentNode.insertBefore(carouselEl, grid.nextSibling);
      grid.style.display = 'none';

      updateCarousel(carouselEl, carouselIndex, cards.length);

    } else if (!isMobile && isCarouselActive) {
      let cards2 = Array.from(carouselEl.querySelectorAll('.mod-boxLink03'));
      cards2.forEach(function (card) { grid.appendChild(card); });
      carouselEl.remove();
      grid.style.display = '';
    }
  }

  function init() {
    let container = document.querySelector('.js-relation-topics');
    if (!container) return;

    let newsId = getNewsId();
    if (!newsId) return;

    fetchJson('/ajax' + $langPath + '/topics/' + newsId + '.json')
      .then(function (currentJson) {
        let currentItem = (currentJson.rt_bn_topics_list || [])[0] || currentJson;

        let tags = (currentItem.cf_t_tags || [])
          .map(function (t) { return t._key; })
          .filter(Boolean);

        let outputTags = (currentItem.cf_t_output_tags || [])
          .map(function (t) { return t._key; })
          .filter(Boolean);

        let outputGroupTags = (currentItem.cf_t_output_tag_group || [])
          .map(function (t) { return t; })
          .filter(Boolean);

        let tagFetches = tags.map(function (tag) {
          return fetchJson('/ajax' + $langPath + '/topics/tag/' + tag + '.json');
        });

        let outputTagFetches = outputTags.map(function (tag) {
          return fetchJson('/ajax' + $langPath + '/topics/output_tag/' + tag + '.json');
        });

        let outputGroupTagFetches = outputGroupTags.map(function (tag) {
          return fetchJson('/ajax' + $langPath + '/topics/output_tag_group/' + tag + '.json');
        });

        return Promise.allSettled(tagFetches.concat(outputTagFetches, outputGroupTagFetches))
          .then(function (results) {
            let seen = {};
            seen[newsId] = true;
            let allItems = [];

            results.forEach(function (result) {
              if (result.status !== 'fulfilled') return;
              let data = result.value;
              let list = Array.isArray(data) ? data : (data.rt_bn_topics_list || data.list || data.items || []);
              // 各JSON内で日付降順に並べ、最新MAX_COUNT件のみを取り出す
              let latestItems = list.slice().sort(function (a, b) {
                let dateA = String(a.cf_t_date || '');
                let dateB = String(b.cf_t_date || '');
                if (dateB !== dateA) return dateB.localeCompare(dateA);
                return String(b._key || '').localeCompare(String(a._key || ''));
              }).slice(0, MAX_COUNT);
              latestItems.forEach(function (item) {
                let key = String(item._key || '');
                if (!key || seen[key]) return;
                seen[key] = true;
                allItems.push(item);
              });
            });

            allItems.sort(function (a, b) {
              let dateA = String(a.cf_t_date || '');
              let dateB = String(b.cf_t_date || '');
              if (dateB !== dateA) return dateB.localeCompare(dateA);
              return String(b._key || '').localeCompare(String(a._key || ''));
            });

            let displayItems = allItems
              .filter(function (item) { return item && item._key; })
              .slice(0, MAX_COUNT);

            if (!displayItems.length) return;

            // 既存カルーセルを削除
            let existingCarousel = container.nextElementSibling;
            if (existingCarousel && existingCarousel.classList.contains('mod-card-carousel')) {
              existingCarousel.remove();
            }
            container.style.display = '';

            container.innerHTML = '';
            displayItems.forEach(function (item) {
              container.appendChild(createCard(item));
            });

            // カルーセル初期化
            setupCarousel(container);
          });
      })
      .catch(function (err) {
        console.error('[relation-topics] error:', err);
      });
  }
  
  function fileSize(_bytes) {	
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (_bytes === 0) {
      return 'n/a';
    }
    let i = parseInt(Math.floor(Math.log(_bytes) / Math.log(1024)), 10);
    if (i === 0) {
      return _bytes + ' ' + sizes[i];
    }
    return (_bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
  };

  window.addEventListener('resize', function () {
    let grid = document.querySelector('.js-relation-topics');
    if (grid) setupCarousel(grid);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();